import {lazy} from "react";
import {CONSTANTS} from "../../constants/constants";

const Home = lazy(() => import("../../pages/Home/Home"));
const NotFoundPage = lazy(() => import("../../pages/NotFoundPage/NotFoundPage"));
const Auth = lazy(() => import("../../pages/Auth/Auth"));
const PropertyList = lazy(() => import("../../pages/searchLists/PropertyList/PropertyList"));
const PropertyDetails = lazy(() => import("../../pages/details/PropertyDetails/PropertyDetails"));
const BookingProperty = lazy(() => import("../../pages/booking/BookingProperty/BookingProperty"));

const {
  NOT_FOUND,
  AUTH,
  HOME,
  PROPERTY,
  CAR,
  TOUR,
  PROPERTY_SEARCH,
  PROPERTY_DETAILS,
  PROPERTY_BOOKING,
} = CONSTANTS.ROUTES;

export const publicRoutes = [
  {
    path: NOT_FOUND.path,
    component: NotFoundPage,
  },
  {
    path: AUTH.path,
    component: Auth,
  },
  {
    path: HOME.path,
    component: Home,
  },
  {
    path: PROPERTY.path,
    component: Home,
  },
  {
    path: CAR.path,
    component: Home,
  },
  {
    path: TOUR.path,
    component: Home,
  },
  {
    path: PROPERTY_SEARCH.path,
    component: PropertyList,
  },
  {
    path: PROPERTY_DETAILS.path,
    component: PropertyDetails,
  },
  {
    path: PROPERTY_BOOKING.path,
    component: BookingProperty,
  },
];